export default __webpack_public_path__ + "static/media/whatMUN.9963bb78.png";